define 'controller/ThreeXController', ['jquery'], ($) ->
  class ThreeXController

    constructor: (@$el) ->
      @_onLoad(@$el)

    _onLoad: (el) ->
      variationExternalKey = el.attr('data')
      $.ajax
        type: 'GET'
        url: '/api/threeX/simulate/variation/' + variationExternalKey
        xhrFields:
          showLoadingIndicator: false
        success: (content) ->
          if content == undefined || content.normalPaymentRate == undefined
            return
          installmentText = el.find('.installment__text').html()
          installmentText = installmentText.replace('{0}', content.normalPaymentRate)
          el.find('.installment__text').html(installmentText)
          el.find('.installment__container').show()
        error: (error) ->
          if(error.status != 404)
            _onload(el)



